import React from "react";
import { Table } from "semantic-ui-react";
import FilaContactos from "./tablaContactos/FilaContactos";

function TablaContactos(props) {
  return (
    <Table celled selectable compact>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell content="Nombre" />
          <Table.HeaderCell content="Descripción" />
          <Table.HeaderCell content="email" />
          <Table.HeaderCell content="Telefono" />
          <Table.HeaderCell content="Descripción" />
          <Table.HeaderCell content="Notas" />
          <Table.HeaderCell content="Acciones" textAlign="center" />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {props.datos.map(contacto => {
          return (
            <FilaContactos
              key={contacto.id}
              datos={contacto}
              handleContactoMail={props.handleContactoMail}
              handleContactoPhone={props.handleContactoPhone}
              handleContactoVisite={props.handleContactoVisite}
              handleClickNuevaPersonaContacto={
                props.handleClickNuevaPersonaContacto
              }
              handleBorrarItem={props.handleBorrarPersonaContacto}
              handleEditItem={props.handleEditPersonaContacto}
              handleDefaultItem={props.handleDefaultPersonaContacto}
            />
          );
        })}
      </Table.Body>
    </Table>
  );
}

export default TablaContactos;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventasNuevaPersonaContacto/TablaContactos.jsx